import { CreatBoletimMedicaoPorContrato } from '@app/api/boletimMedicao';
import { Visibility } from '@app/components/Visibility';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import React, { useEffect, useState } from 'react';
import { PanelCadastroManualCMG } from './PanelCadastroManualCMG';
import { PanelMedicoesCanceladas } from './panelMedicoesCanceladas';
import { PanelResumoMedicoes } from './panelResumoMedicoes';

interface AbaResumoMedicaoCMGProps {
  contratoId: string,
}

export const AbaResumoMedicaoCMG = ({
  contratoId,
}: AbaResumoMedicaoCMGProps) => {

  const [planilhaSelecionada, setPlanilhaSelecionada] = useState<CreatBoletimMedicaoPorContrato>({} as CreatBoletimMedicaoPorContrato);

  return (
    <>

      <PanelCadastroManualCMG
        contratoId={contratoId}
        onPlanilhaSelecionada={setPlanilhaSelecionada}
      />

      <Visibility
        visible={isObjNotEmpty(planilhaSelecionada)}
      >

        <PanelResumoMedicoes
          contratoId={contratoId}
          planilhaSelecionada={planilhaSelecionada}
        />

        <PanelMedicoesCanceladas
          contratoId={contratoId}
          planilhaSelecionada={planilhaSelecionada}
        />

      </Visibility>

    </>
  );
};
